var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isListenerMobile)?_c('ListenerDiscover'):_c('Discover')
}
var staticRenderFns = []

export { render, staticRenderFns }